import type { Severity } from '@revolugo/common/types'

export enum RAlertSeverity {
  Info = 'info',
  Success = 'success',
  Error = 'error',
  Warn = 'warn',
  Secondary = 'secondary',
  Contrast = 'contrast',
}

export interface RAlertProps {
  closable?: boolean
  icon?: string
  message?: string
  severity?: RAlertSeverity | Severity
}
